import React, { ReactNode, useCallback, useMemo, useState, useEffect } from 'react'
import fromPairs from 'ramda/es/fromPairs'

import SearchParamsContext, { Context } from './search-params-context'


type Props = Readonly<{
  children: ReactNode
}>

const SearchParamsRouterProvider = ({ children }: Props) => {
  const [update, setUpdate] = useState('')


  const handleGoto = useCallback((key: string, value: string) => {
    const search = new URLSearchParams(window.location.search)
    if (!value) {
      search.delete(key)
    } else {
      search.set(key, value)
    }
    window.history.pushState({ [key]: value }, '', `?${search.toString()}`)
    const queryStringChange = new Event('popstate')
    window.dispatchEvent(queryStringChange)
  }, [])


  const handleReplace = useCallback((key: string, value: string | void) => {
    const search = new URLSearchParams(window.location.search)
    if (!value) {
      search.delete(key)
    } else {
      search.set(key, value)
    }
    window.history.replaceState({ [key]: value }, '', `?${search.toString()}`)
  }, [])


  const handlePopstate = useCallback((e) => {
    setUpdate(window.location.search)
  }, [])


  const value: Context = useMemo(() => {
    const search = new URLSearchParams(window.location.search)
    const state = fromPairs(Array.from(search.entries()))

    return([state, {
      goto: handleGoto,
      replace: handleReplace,
    }]);
  }, [handleGoto, handleReplace, update]) // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    window.addEventListener('popstate', handlePopstate)

    return () => {
      window.removeEventListener('popstate', handlePopstate)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <SearchParamsContext.Provider value={value}>
      {children}
    </SearchParamsContext.Provider>
  )
}

export default SearchParamsRouterProvider
